import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { PageTitle, PageContent, PageLead } from 'components/Pages';
import Form from 'components/Form';
import { getData, setPassword, saveData } from 'redux/actions/account';
import inputs from './form.json';
import { isMobileOnly } from 'react-device-detect';

const AccountPage = () => {
    const dispatch = useDispatch();
    const { user: userData, loading, form } = useSelector((state) => state.account);

    useEffect(() => {
        dispatch(getData());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const handleSaveUserData = (data) => {
        return dispatch(
            saveData({
                user: data,
                formId: 'accountSuccess',
                target: isMobileOnly ? 'user' : 'top',
                form: 'user',
            }),
        );
    };

    const handleSetNewPassword = (passwords) =>
        dispatch(
            setPassword({
                passwords,
                formId: 'passwordSuccess',
                target: isMobileOnly ? 'password' : 'top',
                form: 'password',
            }),
        );

    return (
        <section className="page">
            <PageTitle
                title={!isMobileOnly && 'Moje Dane'}
                url={isMobileOnly && '#'}
                mobileMessageTarget="user">
                {isMobileOnly && 'Moje Dane'}
            </PageTitle>
            <PageLead>
                <p className="text-center w-tablet-80" style={{ width: '81%' }}>
                    Możesz w każdej chwili edytować swoje dane, aby Twoje konto było zawsze aktualne!
                </p>
            </PageLead>
            <PageContent>
                <div className="account">
                    {(loading && !form) || (form && form === 'user') ? (
                        <Skeleton count={5} height="30px" />
                    ) : (
                            <Form
                                type="user"
                                inputs={inputs.user}
                                data={userData}
                                title="Zmiana danych"
                                handleSubmitEv={handleSaveUserData}
                            />
                        )}
                </div>
            </PageContent>
            <PageTitle
                title={!isMobileOnly && 'Zmiana hasła'}
                url={isMobileOnly && '#'}
                className="margin-top"
                mobileMessageTarget="password">
                {isMobileOnly && 'Zmiana hasła'}
            </PageTitle>
            <PageLead>
                <p className="text-center w-tablet-80">
                    W każdej chwili możesz zmienić swoje hasło, aby Twoje konto było bezpieczne!
                </p>
            </PageLead>
            <PageContent>
                <div className="account">
                    {(loading && !form) || (form && form === 'password') ? (
                        <Skeleton count={4} height="30px" />
                    ) : (
                            <Form
                                type="password"
                                inputs={inputs.password}
                                data={[]}
                                title="Zmiana hasła"
                                submitTitle="Zmień hasło"
                                handleSubmitEv={handleSetNewPassword}
                            />
                        )}
                </div>
            </PageContent>
        </section>
    );
};

export default AccountPage;
